import { defineComponent as _defineComponent } from 'vue'
import { BHTradeStatus } from 'ah-api-gateways';
import StatusPill from 'ah-common-lib/src/common/components/StatusPill.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeStatusPill',
  props: {
    status: null
  },
  setup(__props: any) {



const statusColors = computed<{ [key in BHTradeStatus]: string }>(() => {
  return {
    [BHTradeStatus.OPEN]: 'success',
    [BHTradeStatus.CLOSED]: 'warning',
    [BHTradeStatus.AMENDED]: 'primary',
    [BHTradeStatus.CANCELED]: 'danger',
    [BHTradeStatus.REMAINING_CANCELING]: 'danger',
    [BHTradeStatus.REMAINING_CANCELED]: 'danger',
    [BHTradeStatus.REJECTED]: 'danger',
    [BHTradeStatus.DATE_ROLLED]: 'success',
    [BHTradeStatus.REMAINING_DATE_ROLLED]: 'success',
    [BHTradeStatus.FULLY_SETTLED]: 'primary',
    [BHTradeStatus.REMAINING_SETTLED]: 'primary',
    [BHTradeStatus.OVERDUE]: 'danger',
    [BHTradeStatus.SETTLES_TODAY]: 'primary',
    [BHTradeStatus.SUBMITTED]: 'success',
    [BHTradeStatus.PARTIALLY_OPEN]: 'success',
    [BHTradeStatus.CANCELING]: 'danger',
    [BHTradeStatus.REMAINING_CLOSED]: 'warning',
    [BHTradeStatus.VERIFIED]: 'success',
  };
});

const defaultStatusLabels = computed<{ [key in BHTradeStatus]: string }>(() => {
  return {
    [BHTradeStatus.OPEN]: 'Open',
    [BHTradeStatus.CLOSED]: 'Closed',
    [BHTradeStatus.AMENDED]: 'Amended',
    [BHTradeStatus.REJECTED]: 'Rejected',
    [BHTradeStatus.CANCELED]: 'Cancelled',
    [BHTradeStatus.REMAINING_CANCELING]: 'Cancelled',
    [BHTradeStatus.REMAINING_CANCELED]: 'Cancelled',
    [BHTradeStatus.DATE_ROLLED]: 'Rolled',
    [BHTradeStatus.REMAINING_DATE_ROLLED]: 'Rolled',
    [BHTradeStatus.FULLY_SETTLED]: 'Settled',
    [BHTradeStatus.REMAINING_SETTLED]: 'Partially Settled',
    [BHTradeStatus.OVERDUE]: 'Overdue',
    [BHTradeStatus.SETTLES_TODAY]: 'Settles Today',
    [BHTradeStatus.SUBMITTED]: 'Submitted',
    [BHTradeStatus.PARTIALLY_OPEN]: 'Partially Open',
    [BHTradeStatus.CANCELING]: 'Cancelling',
    [BHTradeStatus.REMAINING_CLOSED]: 'Partially Closed',
    [BHTradeStatus.VERIFIED]: 'Verified',
  };
});

return { __sfc: true,statusColors, defaultStatusLabels, StatusPill }
}

})